import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { EditClientAdminUserForm } from '~/features/EditClientAdminUserForm';
import { EditClientAdminUserFormHeader } from '~/features/EditClientAdminUserFormHeader';
import { ROUTES } from '~/utils/routes';
import styles from '../../styles.module.scss';

export const Screen: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();

  const clientAdminUserId = Number.parseInt(id, 10);
  if (Number.isNaN(clientAdminUserId)) {
    return <Navigate to={ROUTES.ADMINS.INDEX} replace />;
  }

  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <Suspense fallback={<Shimmer />}>
          <EditClientAdminUserFormHeader clientAdminUserId={clientAdminUserId} />
          <main className={styles.body}>
            <EditClientAdminUserForm clientAdminUserId={clientAdminUserId} />
          </main>
        </Suspense>
      </div>
    </div>
  );
};
